import { getKeywords, getVstPluginFilterInfo, getVstPluginConfig } from '../../api/em'
import { cppInstallAutoTunePlugin, cppEnableAudioFFT } from '../../api/cpp'
import getProductInfo from '../../static/getProductInfo';
import { getImgBase64, compareVersions } from '../../utils/index';
import { getIsSetEnableAudioFFT, getComponentNotFree } from './local';
import axios from 'axios';

import {
    cppUpdatePlayerMaskKeywords,
    cppUpdatePluginFilter,
    cppUpdateSupportPlugins,
    cppRunAsyncPluginIdentify,
    cppStartPlayerMonitor,
    cppGetRemoteStatus,
    setWindowTitle,
    cppWriteBase64File,
    cppSetWindowIcon,
    cppReadStringFile,
    cppWriteStringFile,
    cppGetAppInfo,
    cppUpdateMaskProcessList,
} from '../../api/cpp';

// 电音相关初始化
export function initEmConfig (cb) {
    initKeyWord()
    initPluginFilterInfo()
    initPluginConfig(cb)

    // 更新屏蔽进程列表
    cppUpdateMaskProcessList(['yyboxmixerclient.exe'])
    // 开始执行插件识别循环
    cppRunAsyncPluginIdentify();
    // 开始监听播放器
    cppStartPlayerMonitor();
    // 轮询获取插件状态
    getPluginStatus();
    // 修复酷狗插件 仅执行一次
    const isFixKugouPluginFlag = window.localStorage.getItem("em_fix_kugou_plugin");
    if (!isFixKugouPluginFlag) {
        cppInstallAutoTunePlugin("emFix", false);
        window.localStorage.setItem("em_fix_kugou_plugin", "fixed");
    }
    // 初始化播放器频谱
    if (!!window.cppEnableAudioFFT) {
        const enable = getIsSetEnableAudioFFT();
        cppEnableAudioFFT(enable)
    }
    repaireKugouRemixPlugin();
    // const data = {
    //     "entry": ".\\script\\webtool.lua",
    //     "depends": [
    //         {
    //             "url": "https://yuneffect.com/emusic3web/webtool.lua",
    //             "savePath": ".\\script\\webtool.lua"
    //         }
    //     ]
    // }
    // const userData = {
    //     "name": "viveva"
    // }
    // cppRunWebToolFunctionLoadScript(data, userData)
}

// 修复酷狗v20061版本加载不了消人声插件的问题  改为使用桥接插件的方式
export function repaireKugouRemixPlugin() {
    const appInfo = cppGetAppInfo();
    const isNewVersion = compareVersions(appInfo && appInfo.version, "3.9.5");
    // 3.9.5及3.9.5以下的版本才会执行
    if (isNewVersion) {
        return false
    }
    try {
        const playerJson = JSON.parse(cppReadStringFile("./player.json"));
        let flag = false;
        if (playerJson && playerJson.kugou && Array.isArray(playerJson.kugou.plugins)) {
            playerJson.kugou.plugins.forEach(ele => {
                if (ele.name === "消人声" && !ele.bridgePath) {
                    flag = true
                    ele.bridgePath = ".\\rt\\x86\\bg_vst_1.dll"
                    ele.bridge = true
                }
            })
        }
        if (flag) {
            cppWriteStringFile("./player.json", JSON.stringify(playerJson));
        }
    } catch (error) {
    }
}

// 产品信息
export function initProduct() {
    return new Promise((resolve, reject) => {
        getProductInfo().then(productInfo => {
            resolve(productInfo)
            setWindowTitle(productInfo.title);
            getImgBase64(productInfo.ico, function(base64) {
                const writeFileState = cppWriteBase64File(productInfo.WindowIconFileName, base64);
                if (writeFileState) {
                    cppSetWindowIcon(productInfo.WindowIconFileName);
                }
            })
        }).catch((dPro) => {
            resolve(dPro)
        })
    })
};

// 设置播放器屏蔽关键词
function initKeyWord(retryCount = 0, maxRetries = 3) {
    getKeywords().then(res => {
        if (res && res.err === 'ERR_OK') {
            cppUpdatePlayerMaskKeywords(res)
        }
    }).catch(err => {
        retryCount++;
        if (retryCount < maxRetries) {
            setTimeout(() => {
                initKeyWord(retryCount, maxRetries);
            }, 2000);
        }
    })
}

// 设置插件筛选信息
function initPluginFilterInfo(retryCount = 0, maxRetries = 3) {
    getVstPluginFilterInfo().then(res => {
        if (res && res.err === 'ERR_OK') {
            cppUpdatePluginFilter(res)
        }
    }).catch(err => {
        retryCount++;
        if (retryCount < maxRetries) {
            setTimeout(() => {
                initPluginFilterInfo(retryCount, maxRetries);
            }, 2000);
        }
    })
}

// 设置插件配置信息
function initPluginConfig(cb, retryCount = 0, maxRetries = 3) {
    getVstPluginConfig().then(res => {
        if (res && res.err === 'ERR_OK') {
            // 临时使用
            if (res.emPlugsV3 && Array.isArray(res.emPlugsV3.emVst3Plugs)) {
                res.emPlugsV3.emVst3Plugs.forEach(ele => {
                    if (ele.plugName === "电音10 Pro" || ele.plugName === "电音9 Pro" || ele.plugName === "电音 8.1") {
                        ele.vibratoIndex = 62;
                        ele.vibratoStep = 0.01;
                        ele.trackingIndex = 9;
                        ele.trackingStep = 0.01;
                    }
                });
                res.emPlugsV3.emVst3Plugs.push({
                    emVer: "EM_VERSION_3",
                    plugName: "xpitch",
                    pluginFileName: "Xpitch.vst3",
                    emKeyboard: [1718345651, 1718345652, 1718345653, 1718345654, 1718345655, 1718345656, 1718345657, 1718345658, 1718345659, 1718345660, 1729107708, 1729107709],
                    vst3Cids: ["ABCDEF019182FAEB4E75726F58706974"],
                    speedDefaultPos: 50,
                    speedIndex: 441993146,
                    speedStep: 0.01005
                })
            }
            // 释放组件
            const freeComponent = !getComponentNotFree();
            res.freeComponent = freeComponent
            // console.log(res.emPlugsV3);

            // res.emPlugsV3.emVst3Plugs.push({
            //     emVer: "EM_VERSION_3",
            //     plugName: "MetaTune",
            //     pluginFileName: "MetaTune.vst3",
            //     emKeyboard: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            //     vst3Cids: ["D9F32002412B461FA5657F5D0E9A951D"]
            // })
            // res.emPlugsV3.emPlugs.push({
            //     emVer: "EM_VERSION_2",
            //     plugName: "MetaTune vst2",
            //     pluginFileName: "MetaTune.dll",
            //     emKeyboard: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            //     uniqueId: 1298494548
            // })
            cppUpdateSupportPlugins(res)
            cb && cb(res.emPlugsV3)
        }
    }).catch(err => {
        retryCount++;
        if (retryCount < maxRetries) {
            setTimeout(() => {
                initPluginConfig(cb, retryCount, maxRetries);
            }, 2000);
        }
    })
}

// 轮询获取插件状态
function getPluginStatus() {
    cppGetRemoteStatus();
    setTimeout(() => {
        getPluginStatus();
    }, 2000)
}

// 获取本地配置
export function getLocalCnfJSON() {
    return axios("https://em.yuneffect.com/emusic3web/cnf.json")
}
